import 'regenerator-runtime/runtime';
import {
  createStore, applyMiddleware, compose, combineReducers,
} from 'redux';
import createSagaMiddleware from 'redux-saga';

import app from './services/appService';
import transactions from './services/transactionsService';
import downloadTransactionsCSV from './services/downloadCSVService';
import image from './services/imageService';
import downloadZip from './services/downloadZipService';
import account from './services/accountService';
import requests from './services/changeRequestsService';
import categories from './services/categoryService';
import xero from './services/xeroService';

const reducer = combineReducers({
  appService: app.reducer,
  transactionsService: transactions.reducer,
  downloadTransactionsCSVService: downloadTransactionsCSV.reducer,
  imageService: image.reducer,
  downloadZipService: downloadZip.reducer,
  accountService: account.reducer,
  requestsService: requests.reducer,
  categoriesService: categories.reducer,
  xeroService: xero.reducer,
});

export default function configureStore(preloadedState = {}) {
  const sagaMiddleware = createSagaMiddleware();
  // eslint-disable-next-line no-underscore-dangle
  const devTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  const composeEnhancer = devTools ? devTools({ name: 'anna-ws-accountants' }) : compose;

  const middlewares = [sagaMiddleware];

  const store = createStore(
    reducer,
    preloadedState,
    composeEnhancer(
      applyMiddleware(
        ...middlewares,
      ),
    ),
  );

  sagaMiddleware.run(transactions.sagas);
  sagaMiddleware.run(downloadTransactionsCSV.sagas);
  sagaMiddleware.run(image.sagas);
  sagaMiddleware.run(downloadZip.sagas);
  sagaMiddleware.run(account.sagas);
  sagaMiddleware.run(requests.sagas);
  sagaMiddleware.run(categories.sagas);
  sagaMiddleware.run(xero.sagas);

  return store;
}
